<template>
  <div id="checkout-thankyou" class="container thankyou-page">
    <div v-if="status != false">
      <div class="container box-content" v-if="status == 'success'">
        <app-invoice :invoice_no="invoice_no" :show_heading="true"></app-invoice>
      </div>
      <div class="small-content-container page-not-found" v-else-if="status == 'payment_error'">
        <div class="container box-content small-content zoom-in">
          <h2>{{ $t('order.payment_error_description') }}</h2>
          <div>
            <router-link
                :to="{ name: 'my-account', params: { page: 'orders' } }"
            >{{ $t('order.see_orders') }}
            </router-link>
          </div>
          <div>{{ $t('order.or') }}</div>
          <div>
            <router-link :to="'/'">{{ $t('order.go_home') }}</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/services/api-service';
import Invoice from '@/components/shop/order/Invoice.vue';

export default {
  components: {
    'app-invoice': Invoice
  },
  data () {
    return {
      status: false,
      is_new: false,
      order: false,
      invoice_no: this.$route.query.invoice_no
    };
  },
  created () {
    this.$store.dispatch('resetCart');
    this.$store.dispatch('fetchCoupon', {
      name: '',
      msg: false,
      coupon_amount: 0,
      discount_type: '',
      disabled: true
    });
    this.status = 'success';
  }
};
</script>
<style lang="scss">
.thankyou-page {
  h1 {
    font-size: 24px;
    font-family: $font-bold;
    margin-top: 0;
    margin-bottom: 15px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;

    &.order-products {
      tbody {
        tr {
          &:nth-child(2n + 1) {
            background: rgba(0, 0, 0, 0.1);
          }

          td {
            a {
              color: #000;
            }
          }
        }
      }

      td {
        padding: 10px;

        &:nth-child(4),
        &:nth-child(5) {
          text-align: right;
        }
      }

      tfoot {
        text-align: right;

        table {
          border-top: 1px solid #000000;
        }
      }
    }

    td {
      padding: 7px 0;
      vertical-align: top;
    }

    th {
      text-align: left;
    }

    h2 {
      margin: 0;
      font-size: 18px;
      margin-bottom: 15px;
      font-family: $font-medium;
    }
  }
}
</style>
